import { Typography, Button } from '@mui/material';

import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import Divider from '@mui/material/Divider';
import { Utils } from '../../../utils/utils';

export default function PostOrderDetails(props) {

    const formattedOrderDateTime = Utils.formatISODateToStandard(props.order.orderDate);

        function formatToTwoDecimalPlaces(amount) {
            return Number(amount || 0).toFixed(2);
        }

        const deliveryDistanceMiles = Number(props.order.deliveryDistanceMiles || 0);
        const deliveryFee = Number(props.order.deliveryFee || 0);
        const deliveryRatePerMile = deliveryDistanceMiles > 0 ? deliveryFee / deliveryDistanceMiles : 0;

    return (
        <div style={{ maxWidth: 480 }}>
          <Typography variant="h5" mb={0} gutterBottom style={{ color: 'green'}}>
            Your order was successfully processed
          </Typography>
          <p style={{ marginTop: 0}}>Please press Delivery Completed when received</p>
          
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', paddingLeft: 24, paddingTop: 16 }}>
            <div style={{ flexGrow: 1 }}>
                <Typography variant="subtitle1">
                Order Number: <b>{props.order.orderNumber}</b>
                </Typography>
                <Typography variant="subtitle1">
                Status: <span style={{ color: 'green', fontWeight: 'bold'}}>{props.order.status}</span>
                </Typography>
                <Typography variant="subtitle1">
                    Date: {formattedOrderDateTime}
                </Typography>
                <Typography variant="subtitle1">
                    Method: {props.order.deliveryMethod}
                </Typography>
                
            </div>
            <div style={{ flexGrow: 1 }}>
                <Typography mt={3} variant="h6" style={{ color: 'gray' }}>Details</Typography>
                {
                    props.order.items.map((item, index) => (
                        <div key={index} style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span>{item.itemName + ' (' + item.count + ')'}:</span>
                            <span style={{ marginLeft: 24 }}>${item.price}</span>
                        </div>
                    ))
                }

                <div style={{ marginTop: 24, display: 'flex', justifyContent: 'space-between' }}>
                    <span>Item(s) Subtotal:</span>
                                        <span style={{ marginLeft: 24 }}>${formatToTwoDecimalPlaces(props.order.itemsSubTotal)}</span>
                </div>
                                {deliveryFee > 0 && (
                                    <>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <span>Delivery Fee:</span>
                                            <span style={{ marginLeft: 24 }}>${formatToTwoDecimalPlaces(deliveryFee)}</span>
                                        </div>
                                        <div style={{ fontSize: '0.8rem', color: '#666', marginTop: 2 }}>
                                            <span>
                                                {formatToTwoDecimalPlaces(deliveryDistanceMiles)} miles × ${formatToTwoDecimalPlaces(deliveryRatePerMile)}/mile
                                            </span>
                                        </div>
                                    </>
                                )}
                {/* <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Fees:</span>
                    <span style={{ marginLeft: 24 }}>${props.order.fees}</span>
                </div> */}
                <Divider style={{ marginBottom: 8, marginTop: 16 }} />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Grand Total:</span>
                                        <span style={{ marginLeft: 24 }}>${formatToTwoDecimalPlaces(props.order.totalAmount)}</span>
                </div>
            </div>
            
          </div>

        </div>
      );
}